module.exports = __webpack_public_path__ + "assets/4e1d376924b51e5bb4ada242345a8bee.png";